const FORM_ITEM_INJECTION_KEY = Symbol("FORM_ITEM_INJECTION_KEY"), LAYOUT_INJECTION_KEY = Symbol("FORM_LAYOUT_KEY");
export {
  FORM_ITEM_INJECTION_KEY,
  LAYOUT_INJECTION_KEY
};
//# sourceMappingURL=injectionKeys.js.map
